export enum screenview {
  trackerDash = 0,
  updateWeight = 1,
  motivation = 2,
}
